import script from "./ServiceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceSection.vue?vue&type=script&setup=true&lang=js"

import "./ServiceSection.vue?vue&type=style&index=0&id=27c39ad8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c39ad8"]])

export default __exports__